// This validator takes a maximum age, two control names containing NgbDateStruct values, and an AgeService
// The age is calculated using the birthDateControlName FormControl value as the Birth Date and
// the calcDateControlName FormControl value as the date on which the age should be calculated
// The AgeService contains the age calculation logic

import { AbstractControl, ValidatorFn } from "@angular/forms"
import { AgeService } from '../../services/age.service';

export function MaxAgeValidator(birthDateControlName: string, calcDateControlName: string, maxAge: number, ageService: AgeService): ValidatorFn {
  return (group: AbstractControl): { [key: string]: any } | null => {
    let birthDateControl = group.get(birthDateControlName);
    let calcDateControl = group.get(calcDateControlName);

    if (!birthDateControl.value || birthDateControl.invalid ||
      !calcDateControl.value || calcDateControl.invalid)
      return null;

    var birthDate = new Date(birthDateControl.value.year, birthDateControl.value.month, birthDateControl.value.day);
    var calcDate = new Date(calcDateControl.value.year, calcDateControl.value.month, calcDateControl.value.day);

    var age = ageService.computeAge(birthDate, calcDate);
    if (age && age > maxAge)
      return { "maxAge": true };

    return null;
  }
}
